import BonusesLogo from "assets/icons/Bounus.svg";
import NewsLogo from "assets/icons/i_news.svg";
import TournamentsLogo from "assets/icons/Tournament.svg";
import { CATEGORY_GAME } from "contants/game-type";
import { PATH } from "contants/path";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import { useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { selectCategoryGameList } from "store/game";
import { getGameList } from "store/game/game.thunk";
import {
  CategoryGameListType,
  CategoryGameType,
  GameListResponseType,
} from "types/game";

import StyledHeaderSub from "./index.style";

const HeaderSub = () => {
  const { categoryId } = useParams();
  const { pathname: pathCategory } = useLocation();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const categoryGameList = useAppSelector(selectCategoryGameList);

  useEffect(() => {
    if (!categoryId) return;

    if (pathCategory.includes(categoryId) && categoryGameList.length > 0)
      return;

    const findCategoryGame = CATEGORY_GAME.find((category: CategoryGameType) =>
      category.path.includes(`/${categoryId}`)
    );

    if (!findCategoryGame) return;

    dispatch(getGameList(findCategoryGame.id));
  }, [categoryId, pathCategory, categoryGameList.length]);

  const handleAction = async (categoryGame: CategoryGameType) => {
    const res = await dispatch(getGameList(categoryGame.id));

    const dataRes = res.payload as GameListResponseType;
    const { data: listGame } = dataRes;

    if (!listGame.length) return;
    const findGame = listGame.find(
      (game: CategoryGameListType) => game.provider_name
    );

    if (!findGame) return;
    navigate(`${categoryGame.path}/${findGame.provider_code}`);
  };

  return (
    <StyledHeaderSub>
      <div className="header-3rd">
        <div className="header__wrap">
          <div className="menu__wrap">
            {CATEGORY_GAME.map((categoryGame: CategoryGameType) => (
              <div key={categoryGame.id} className="menu__wrap-item">
                <div onClick={() => handleAction(categoryGame)} className="box">
                  {typeof categoryGame.icon == "string" ? (
                    <img src={categoryGame.icon} alt="" className="box-icon" />
                  ) : (
                    <>{categoryGame.icon}</>
                  )}
                  <div className="box-text"> {categoryGame.name}</div>
                </div>
              </div>
            ))}
            <div className="menu__wrap-item">
              <Link to={PATH.newsPage} className="box">
                <img src={NewsLogo} alt="" className="box-icon" />
                <div className="box-text">News</div>
              </Link>
            </div>
            <div className="menu__wrap-item">
              <Link to={PATH.bonusPage} className="box">
                <img src={BonusesLogo} alt="" className="box-icon" />
                <div className="box-text">Bonuses</div>
              </Link>
            </div>
            <div className="menu__wrap-item">
              <Link to={PATH.tournamentsPage} className="box">
                <img src={TournamentsLogo} alt="" className="box-icon" />
                <div className="box-text">Tournaments</div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </StyledHeaderSub>
  );
};

export default HeaderSub;
